import React from 'react';
import arrow from '../../assets/svg/up-arrow.svg';
import './ArrowToTop.scss';

import 'aos/dist/aos.css';

export default function ArrowToTop() {

    const scrollToSection = (sectionId) => {
        const element = document.getElementById("main");
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="arrow-to-top-container">
            <a onClick={() => scrollToSection()}>
                <img src={arrow} alt={arrow} data-aos="fade-up" data-aos-offset="800" data-aos-once="false" />
            </a>
        </div>
    );
}

